(function () {
  'use strict';

  var currentParams = new URLSearchParams(window.location.search);

  if (!currentParams.toString()) {
    return;
  }

  function appendCurrentParams(rawUrl) {
    var targetUrl;

    try {
      targetUrl = new URL(rawUrl, window.location.href);
    } catch (error) {
      return rawUrl;
    }

    if (!/^https?:$/.test(targetUrl.protocol)) {
      return rawUrl;
    }

    currentParams.forEach(function (value, key) {
      if (!targetUrl.searchParams.has(key)) {
        targetUrl.searchParams.append(key, value);
      }
    });

    return targetUrl.href;
  }

  function updateLink(link) {
    var href = link.getAttribute('href');

    if (
      !href ||
      href.charAt(0) === '#' ||
      link.hasAttribute('download') ||
      link.hasAttribute('data-no-query-params') ||
      /^(?:mailto|tel|sms|javascript|data):/i.test(href)
    ) {
      return;
    }

    link.href = appendCurrentParams(href);
  }

  function updateGemPagesButton(button) {
    var rawData = button.getAttribute('gp-data');
    var buttonData;

    if (!rawData || button.hasAttribute('data-no-query-params')) {
      return;
    }

    try {
      buttonData = JSON.parse(rawData);
    } catch (error) {
      return;
    }

    if (!buttonData.btnLink || !buttonData.btnLink.link) {
      return;
    }

    buttonData.btnLink.link = appendCurrentParams(buttonData.btnLink.link);
    button.setAttribute('gp-data', JSON.stringify(buttonData));
  }

  function handleLinkInteraction(event) {
    var link = event.target.closest && event.target.closest('a[href]');
    var gemPagesButton = event.target.closest && event.target.closest('gp-button[gp-data]');

    if (link) {
      updateLink(link);
    }

    if (gemPagesButton) {
      updateGemPagesButton(gemPagesButton);
    }
  }

  document.addEventListener('click', handleLinkInteraction, true);
  document.addEventListener('auxclick', handleLinkInteraction, true);
  document.querySelectorAll('a[href]').forEach(updateLink);
  document.querySelectorAll('gp-button[gp-data]').forEach(updateGemPagesButton);

  window.queryParamsHolder = {
    appendToUrl: appendCurrentParams,
    updateLink: updateLink,
    updateGemPagesButton: updateGemPagesButton
  };
})();
